import mutations from "../mutations";
import { getUniqueArrByKey } from "@/helpers";

const {
  SET_CONTACTS,
  SET_LAST_INVOICE,
  SET_PACKAGE,
  SET_BALANCE,
  SET_INVOICES,
  SET_SERVICES,
  SET_PRODUCTS,
  SET_PACKAGES,
} = mutations;

import * as clientDashboardApi from "@/backend/clientDashboardApi.js";

export default {
  namespaced: true,
  state: {
    contacts: {},
    recommendedPackage: {},
    balance: {},
    lastInvoice: {
      amount: 0,
      date: "",
      id: 0,
      number: "",
      paymentStatus: 0,
      payments: [],
      paymentsAmount: 0,
    },
    invoices: [],
    services: [],
    products: [],
    packages: [],
  },
  getters: {
    getServicesByType: ({ services }) => ({ id }) => services.filter((as) => as.type.id === id),
    uniqueServiceTypes: ({ services }) => getUniqueArrByKey(services.map(({ type }) => type), "title"),
    isPositiveBalance: ({ balance }) => balance.balanceAmount > 0,
  },
  mutations: {
    [SET_CONTACTS](state, contacts) {
      state.contacts = contacts;
    },
    [SET_PACKAGE](state, recommendedPackage) {
      state.recommendedPackage = recommendedPackage;
    },
    [SET_BALANCE](state, balance) {
      state.balance = balance;
    },
    [SET_LAST_INVOICE](state, invoice) {
      state.lastInvoice = invoice;
    },
    [SET_INVOICES](state, invoices) {
      state.invoices = invoices;
    },
    [SET_SERVICES](state, services) {
      state.services = services;
    },
    [SET_PRODUCTS](state, products) {
      state.products = products;
    },
    [SET_PACKAGES](state, packages) {
      state.packages = packages;
    },
  },
  actions: {
    async getContacts({ commit }) {
      const contacts = await clientDashboardApi.getContacts();
      commit(SET_CONTACTS, contacts);
    },
    async getPackage({ commit }) {
      const recommendedPackage = await clientDashboardApi.getPackage();
      commit(SET_PACKAGE, recommendedPackage);
    },
    async getBalance({ commit, dispatch, getters }) {
      const balance = await clientDashboardApi.getBalance();
      commit(SET_BALANCE, balance);
      if (!getters.isPositiveBalance) {
        dispatch("getPackage");
      }
    },
    async getLastInvoice({ commit }) {
      const invoice = await clientDashboardApi.getLastInvoice();
      commit(SET_LAST_INVOICE, invoice);
    },
    async getInvoices({ commit }) {
      const invoices = await clientDashboardApi.getInvoices();
      commit(SET_INVOICES, invoices);
    },
    async getServices({ commit }) {
      commit(SET_SERVICES, []);
      // Будет исправлено при очищении хранилища после разлогина
      const services = await clientDashboardApi.getServices();
      commit(SET_SERVICES, services);
    },
    async getProducts({ commit }) {
      const products = await clientDashboardApi.getProducts();
      commit(SET_PRODUCTS, products);
    },
    async getPackages({ commit }, filter) {
      const packages = await clientDashboardApi.getClientPackages(filter);
      commit(SET_PACKAGES, packages);
    },
  },
};
